import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { selectDevice } from 'hooks/deviceInfo'
import { useSelector } from 'react-redux'
import { timerAlert } from 'util/util'

import { useSpring, animated, useTransition } from '@react-spring/web'

import Bg from 'assets/img/cps/tennis/TennisBG.png'
import tennisStabilitySpeed from 'assets/img/cps/tennis/tennisStabilitySpeed.png'
import tennisStability from 'assets/img/cps/tennis/tennisStability.png'
import tennisSpeed from 'assets/img/cps/tennis/tennisSpeed.png'
import TennisAllCourt from 'assets/img/cps/tennisAllCourt.png'
import TennisBaseline from 'assets/img/cps/tennisBaseline.png'
import TennisBestOfBoth from 'assets/img/cps/tennisBestOfBoth.png'

import { apiSaveLog, apiThumbnailList } from 'api/api'

import NavigateButton from 'components/NavigateButton'
import React from 'react'

import BgImg from 'assets/img/cps/bg20260721.png'

const Container = styled.div`
	background-image: url(${BgImg});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	padding: 35px 55px 160px 75px;
	position: relative;
`

const MenuContainer = styled.div`
	position: relative;
	padding-top: calc(220px - 55px);
	.itemInner {
		display: flex;
		justify-content: space-between;
		align-items: top;
	}
	.itemContainer {
		position: relative;
		// position: relative;
		// width: 557px;
		// height: 718px;
		// padding-top: 340px;
		// display: flex;
		&.i1 {
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: 650px;
		}
		&.i2 {
			position: absolute;
			top: 370px;
			left: 70px;
		}
		&.i3 {
			position: absolute;
			top: 370px;
			right: 100px;
		}
	}
	.listItem {
		list-style: none;
		padding: 0;
		margin: 0;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		li {
			width: 50%;
			padding-left: 10px;
			padding-right: 10px;
			img {
				max-width: 100%;
				display: block;
				margin-left: auto;
				margin-right: auto;
			}
		}
	}
	// .listItem {
	// 	transform: translateY(-40px);
	// 	list-style: none;
	// 	margin: 0;
	// 	padding: 0;
	// 	display: flex;
	// 	justify-content: center;
	// 	li {
	// 		width: 50%;
	// 		height: 280px;
	// 		padding: 0 10px;
	// 		img {
	// 			max-width: 100%;
	// 		}
	// 	}
	// }
`

const PageTitle = styled.div`
	position: absolute;
	top: 60px;
	left: 60px;
	font-size: 40px;
	color: #494949;
	width: 210px;
	text-align: center;
	line-height: 1;
	.bar {
		width: 100%;
		height: 10px;
		background: #515151;
		margin: 15px 0;
	}
	span {
		font-size: 55px;
	}
`

const CpsList = () => {
	const location = useLocation()
	const deviceInfo = useSelector(selectDevice)
	const navigate = useNavigate()

	const [baseLineList, setBaseLineList] = useState<any[]>([])
	const [allCourtList, setAllCourtList] = useState<any[]>([])
	const [bestOfBothList, setBestOfBothList] = useState<any[]>([])

	const menuMove1 = useSpring({
		from: { opacity: 0, y: 0 },
		to: { opacity: 1, y: 0 },
		delay: 100,
	})

	const onItemClick = (item: any, itemType: any, subTitlte: string) => {
		item.subsortId = location.state.item.subsortId
		item.pageTitle = itemType
		item.subPageTItle = location.state?.item?.title
		item.subTitlte = subTitlte

		const logRequest = {
			userId: deviceInfo.userId,
			kioskDeviceId: deviceInfo.kioskDeviceId,
			categoryId: deviceInfo.categoryId,
			productId: item.productId,
			subSortId: location.state?.item?.subsortId,
		}
		if (
			logRequest.userId &&
			logRequest.kioskDeviceId &&
			logRequest.categoryId &&
			logRequest.productId &&
			logRequest.subSortId
		) {
			apiSaveLog(logRequest)
		}

		navigate(`/cps/tennis/view`, { state: { item } })
	}

	const [stbNspdList, setStbList] = useState<any[]>([])
	const [stbList, setStbNspdList] = useState<any[]>([])
	const [spdList, setNspdList] = useState<any[]>([])

	useEffect(() => {
		const { item } = location.state
		console.log(item)
		if (item) {
			const request = {
				subsortId: item.subsortId,
				kioskDeviceId: deviceInfo.kioskDeviceId,
			}
			apiThumbnailList(request).then((res) => {
				console.log(res)
				// cpsCategoryId
				{
					/* subSortId가 6이면 (테니스) cpsCate1, 7이면 (배구) cpsCate2, 8이면 (트랙엔필드) cpsCate3, 12면 (기타) cpsCate4 */
				}
				// const cpsCate1 = [
				// 	{ id: 1, cate: 'STABILITY & SPEED', value: 'STABILITY & SPEED' },
				// 	{ id: 2, cate: 'STABILITY', value: 'STABILITY' },
				// 	{ id: 3, cate: 'SPEED', value: 'SPEED' },
				// ]
				// const cpsCate2 = [
				// 	{ id: 4, cate: 'SPEED', value: 'SPEED' },
				// 	{ id: 5, cate: 'CUSHION', value: 'CUSHION' },
				// 	{ id: 6, cate: 'STABILITY', value: 'STABILITY' },
				// ]
				// const cpsCate3 = [
				// 	{ id: 7, cate: 'Short Distance', value: 'Short Distance' },
				// 	{ id: 8, cate: 'Middle Distance', value: 'Middle Distance' },
				// 	{ id: 9, cate: 'Long Distance', value: 'Long Distance' },
				// ]
				// const cpsCate4 = [
				// 	{ id: 10, cate: 'INDOOR', value: 'INDOOR' },
				// 	{ id: 11, cate: 'BASKETBALL', value: 'BASKETBALL' },
				// 	{ id: 12, cate: 'WRESTLING', value: 'WRESTLING' },
				// 	{ id: 13, cate: 'WORKING', value: 'WORKING' },
				// ]
				res.forEach((element: any) => {
					const { productId } = element
					if (productId === 149 || productId === 150) {
						setStbList((prev) => [...prev, element])
					} else if (productId === 147) {
						setStbNspdList((prev) => [...prev, element])
					} else if (productId === 146 || productId === 148) {
						setNspdList((prev) => [...prev, element])
					}

					// if (element.name.startsWith('GEL')) {
					// 	setBaseLineList((prev) => [...prev, element])
					// } else if (element.name.startsWith('SOL')) {
					// 	setAllCourtList((prev) => [...prev, element])
					// } else if (element.name.startsWith('COU')) {
					// 	setBestOfBothList((prev) => [...prev, element])
					// }
				})
			})
		}
		const disablePinchZoom = (e: any) => {
			if (e.touches.length > 1) {
				e.preventDefault()
			}
		}
		document.addEventListener('touchmove', disablePinchZoom, {
			passive: false,
		})
		return () => {
			document.removeEventListener('touchmove', disablePinchZoom)
		}
	}, [])

	return (
		<Container className="container">
			{/* <PageTitle>
				<animated.div style={titleMove}>
					<span className="asics-bold-italic">TENNIS</span>
				</animated.div>
			</PageTitle> */}
			<MenuContainer>
				<animated.div
					className="itemInner"
					style={menuMove1}
				>
					<div className="itemContainer i1">
						<ul className="listItem">
							{stbNspdList
								.filter((item: any) => item.pdbkProductId === undefined)
								.map((item: any, index: number) => {
									return (
										<React.Fragment key={item.fileId}>
											<li
												style={{
													width:
														stbNspdList.filter(
															(item: any) => item.pdbkProductId === undefined,
														).length === 1
															? '100%'
															: '50%',
												}}
											>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
													alt="heritage"
													onClick={() => onItemClick(item, 'Baseline', 'Stability & Speed')}
												/>
											</li>
										</React.Fragment>
									)
								})}
						</ul>
					</div>
					<div className="itemContainer i2">
						<ul className="listItem">
							{stbList
								.filter((item: any) => item.pdbkProductId === undefined)
								.map((item: any, index: number) => {
									return (
										<React.Fragment key={item.fileId}>
											<li
												style={{
													width:
														stbList.filter((item: any) => item.pdbkProductId === undefined)
															.length === 1
															? '100%'
															: '50%',
												}}
											>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
													alt="heritage"
													onClick={() => onItemClick(item, 'All-Court', 'Stability')}
												/>
											</li>
										</React.Fragment>
									)
								})}
						</ul>
					</div>
					<div className="itemContainer i3">
						<ul className="listItem">
							{spdList
								.filter((item: any) => item.pdbkProductId === undefined)
								.map((item: any, index: number) => {
									return (
										<React.Fragment key={item.fileId}>
											<li
												style={{
													width:
														spdList.filter((item: any) => item.pdbkProductId === undefined)
															.length === 1
															? '100%'
															: '50%',
												}}
											>
												<img
													src={`${process.env.REACT_APP_HOST}/file/view/id/${item.fileId}`}
													alt="heritage"
													onClick={() => onItemClick(item, 'Best of Both', 'Speed')}
												/>
											</li>
										</React.Fragment>
									)
								})}
						</ul>
					</div>
				</animated.div>
			</MenuContainer>
			<NavigateButton />
		</Container>
	)
}

export default CpsList
